// Module "Đơn đặt xe" (mua xe VinFast từ Nhà phân phối) — Phase 6b.
// BE: backend/src/modules/purchase-order (resource REST `purchase-orders`).
//
// LƯU Ý collision: route `/purchase-orders` + folder `view/pages/purchase-orders/`
// đã thuộc module legacy "Phiếu yêu cầu nhập hàng" (permission PO_*). Module này
// dùng path `/vehicle-purchase-orders` + folder `view/pages/vehicle-purchase-orders/`
// + permission PURCHASE_ORDER_* để tránh đè lên feature cũ. (DEC-xxx trong decisions.md)

const PurchaseOrder = () =>
  import(
    /* webpackChunkName: "po-index" */ '@/view/pages/vehicle-purchase-orders/index.vue'
  );
const PurchaseOrderList = () =>
  import(
    /* webpackChunkName: "po-list" */ '@/view/pages/vehicle-purchase-orders/List.vue'
  );
const PurchaseOrderUpsert = () =>
  import(
    /* webpackChunkName: "po-upsert" */ '@/view/pages/vehicle-purchase-orders/Upsert.vue'
  );
const PurchaseOrderDetail = () =>
  import(
    /* webpackChunkName: "po-detail" */ '@/view/pages/vehicle-purchase-orders/Detail.vue'
  );
const SupplierDebtReport = () =>
  import(
    /* webpackChunkName: "po-supplier-debt" */ '@/view/pages/vehicle-purchase-orders/SupplierDebtReport.vue'
  );

export default [
  {
    path: '/vehicle-purchase-orders',
    component: PurchaseOrder,
    children: [
      {
        path: '/',
        name: 'list-purchase-order',
        component: PurchaseOrderList,
        meta: {
          title: 'Đơn đặt xe',
        },
      },
      {
        path: 'create',
        name: 'create-purchase-order',
        component: PurchaseOrderUpsert,
        meta: {
          title: 'Tạo Đơn đặt xe',
        },
      },
      {
        path: ':id/edit',
        name: 'edit-purchase-order',
        component: PurchaseOrderUpsert,
        meta: {
          title: 'Sửa Đơn đặt xe',
        },
        props: true,
      },
      {
        path: ':id',
        name: 'detail-purchase-order',
        component: PurchaseOrderDetail,
        meta: {
          title: 'Chi tiết Đơn đặt xe',
        },
        props: true,
      },
      {
        path: 'reports/supplier-debt',
        name: 'po-supplier-debt-report',
        component: SupplierDebtReport,
        meta: {
          title: 'Công nợ Nhà phân phối',
        },
      },
    ],
  },
];
